const l10n:FooterL10n =  {
  "linkList": {
    "companyLink": "About Us",
    "termsOfService": "Terms of Use",
    "privacyPolicy": "Privacy Policy",
    "guaranteeOfRights": "Rights of the Data Subject",
    "customerSupport": "SUPPORT",
    "cookiePolicy": "Cookie Policy",
    "declarationOfSafety": "Security・Safety Declaration",
    "youthProtectionPolicy": "Youth Protection Policy",
    "communityPolicy": "Community Policy",
    "probability": "probability",
    "operationPolicy": "Operation Policy",
    "doNotSell": "Do Not Sell My Personal Information",
    "gameGrade": "Rating",
    "communityPolicyView": "커뮤니티정책",
    "servicePolicy": "서비스정책",
    "termsOfUse": "Terms of Use",
    "operationPolicyNCJ": "운영방침",
    "reportRightsInfringement": "권리침해신고",
    "ncPrivacyCenter": "NC Privacy Center",
    "commercialTransactions": "특정상거래법에 의거한 표기",
    "settlementFund": "자금결제법에 따른 표시",
    "serviceTerm": "서비스 이용약관",
    "legalDocumentation": "Legal Documentation",
    "googleAPIDisclosure": "Google API Disclosure",
    "report": "신고하기",
    "serviceConsent": "NC Service Consent",
    "careers": "Careers",
    "termsOfMobile": "모바일게임 약관"
  },
  "footerWords": {
    "gameRelatedLaw": "Additional Information Following Gaming Laws",
    "brandInformation": "Company Name Information",
    "copyright": "Copyright",
    "channelingInfo": "NC is a broker who mediates mail order sales of channeling games within plaync, and is not a sales party of the aforementioned sales.<br>All obligations and responsibilities associated with the provided channeling games lay with the individual mail order sales party, and we are not responsible for issues regarding them."
  },
  "infoCS": {
    "businessInformation": "View Business Information",
    "infoAddress": "Company Name: NC Corporation, Co-CEO Kim Taek-Jin, Park Byung-Moo, Business Registration Number: 220-81-43000, <br>E-commerce Registration: 2026-Seongnam Bundang A-0316",
    "infoAddressNCV": "9 RAFFLES PLACE #26-01 REPUBLIC PLAZA SINGAPORE (048619)",
    "mobile": "Address: 12, Daewangpangyo-ro 644beon-gil, Bundang-gu, Seongnam-si, Gyeonggi-do, Republic of Korea. <br>Customer SUPPORT: +82 1600-0020. Fax: +82 02-2186-3550.",
    "pc": "Address: 12, Daewangpangyo-ro 644beon-gil, Bundang-gu, Seongnam-si, Gyeonggi-do, Republic of Korea. <br>Customer SUPPORT: +82 1600-0020. Fax: +82 02-2186-3550.",
    "ncfamilyzone": "Address: 12, Daewangpangyo-ro 644beon-gil, Bundang-gu, Seongnam-si, Gyeonggi-do, Republic of Korea. <br>Customer SUPPORT: +82 1600-0020. Fax: +82 02-2186-3550.",
    "other": "Address: 12, Daewangpangyo-ro 644beon-gil, Bundang-gu, Seongnam-si, Gyeonggi-do, Republic of Korea. <br>Customer SUPPORT: +82 1600-0020. Fax: +82 02-2186-3550.",
    "none": "",
    "infoEmail": "E-mail",
    "infoEmail-mobile": "MobileCS@ncsoft.com",
    "infoEmail-pc": "credit@ncsoft.com",
    "infoEmail-ncfamilyzone": "ncfamilyzone@ncsoft.com",
    "infoEmail-other": "credit@ncsoft.com/(PC Game)/MobileCS@ncsoft.com/(Mobile Game)",
    "infoEmail-none": ""
  },
  "infoJP": {
    "jpTitle": "Title",
    "jpGenre": "Genre",
    "jpPrice": "Price",
    "jpPriceValue": "Free to Play (Contains in-app purchases)",
    "jpOs": "Supported OS",
    "jpPlatform": "Platform",
    "jpDevelopedBy": "Developer/Publisher",
    "jpReleaseDay": "Release Date",
    "jpReleaseDayValue_LW": "04 Novemver 2021"
  },
  "country": {
    "KR": "Republic of Korea",
    "TW": "Taiwan",
    "RU": "Russia",
    "MY": "Malaysia",
    "SA": "Saudi Arabia",
    "SG": "Singapore",
    "AE": "United Arab Emirates",
    "ID": "Indonesia",
    "JP": "Japan",
    "QA": "Qatar",
    "TH": "Thailand",
    "PH": "Philippines",
    "HK": "Hong Kong",
    "UA": "Ukraine",
    "BY": "Belarus",
    "LT": "Lithuania",
    "PL": "Poland",
    "GR": "Greece",
    "IL": "Israel",
    "KW": "Kuwait",
    "AT": "Austria",
    "US": "United States of America",
    "CA": "Canada",
    "DE": "Germany",
    "GB": "United Kingdom",
    "FR": "France",
    "BR": "Brazil",
    "IT": "Italy",
    "ES": "Spain",
    "CL": "Chile",
    "NO": "Norway",
    "SE": "Sweden",
    "IE": "Ireland",
    "PT": "Portugal",
    "FI": "Finland",
    "DK": "Denmark",
    "CH": "Switzerland",
    "AR": "Argentina",
    "PE": "Peru",
    "MX": "Mexico",
    "KZ": "Kazakhstan",
    "UZ": "Uzbekistan",
    "AZ": "Azerbaijan",
    "GE": "Georgia",
    "MD": "Moldova",
    "AM": "Armenia",
    "MO": "Macao",
    "IN": "India",
    "PK": "Pakistan",
    "NL": "Netherlands",
    "RO": "Romania",
    "AU": "Australia",
    "TR": "Turkey",
    "EC": "Ecuador",
    "CO": "Colombia",
    "ZA": "South Africa",
    "EG": "Egypt",
    "NC": "Global"
  }
};

export default l10n;
